export const DASH_LINK_BASE = process.env.NEXT_PUBLIC_BASE_URL || 'http://localhost:3000';

/**
 * Business insurance ...
 */

export const DASH_LINK_BUSINESS_INSURANCE_QUOTE_NEW = `${DASH_LINK_BASE}/quotes/business-insurance-quote`;
export const DASH_LINK_BUSINESS_INSURANCE_QUOTE_DETAILS = `${DASH_LINK_BASE}/quotes/business-insurance-quote/details/`;
export const DASH_LINK_BUSINESS_INSURANCE_QUOTE_EDIT = `${DASH_LINK_BASE}/quotes/business-insurance-quote/edit/`;
export const DASH_LINK_BUSINESS_INSURANCE_QUOTE_LIST = `${DASH_LINK_BASE}/quotes/business-insurance-quote/list`;

/**
 * Car insurance ...
 */

export const DASH_LINK_CAR_INSURANCE_QUOTE_NEW = `${DASH_LINK_BASE}/quotes/car-insurance-quote`;
export const DASH_LINK_CAR_INSURANCE_QUOTE_DETAILS = `${DASH_LINK_BASE}/quotes/car-insurance-quote/details/`;
export const DASH_LINK_CAR_INSURANCE_QUOTE_EDIT = `${DASH_LINK_BASE}/quotes/car-insurance-quote/edit/`;
export const DASH_LINK_CAR_INSURANCE_QUOTE_LIST = `${DASH_LINK_BASE}/quotes/car-insurance-quote/list`;

/**
 * Van insurance ...
 */

export const DASH_LINK_VAN_INSURANCE_QUOTE_NEW = `${DASH_LINK_BASE}/quotes/van-insurance-quote`;
export const DASH_LINK_VAN_INSURANCE_QUOTE_DETAILS = `${DASH_LINK_BASE}/quotes/van-insurance-quote/details/`;
export const DASH_LINK_VAN_INSURANCE_QUOTE_EDIT = `${DASH_LINK_BASE}/quotes/van-insurance-quote/edit/`;
export const DASH_LINK_VAN_INSURANCE_QUOTE_LIST = `${DASH_LINK_BASE}/quotes/van-insurance-quote/list`;

/**
 * Taxi insurance ...
 */

export const DASH_LINK_TAXI_INSURANCE_QUOTE_NEW = `${DASH_LINK_BASE}/quotes/taxi-insurance-quote`;
export const DASH_LINK_TAXI_INSURANCE_QUOTE_DETAILS = `${DASH_LINK_BASE}/quotes/taxi-insurance-quote/details/`;
export const DASH_LINK_TAXI_INSURANCE_QUOTE_EDIT = `${DASH_LINK_BASE}/quotes/taxi-insurance-quote/edit/`;
export const DASH_LINK_TAXI_INSURANCE_QUOTE_LIST = `${DASH_LINK_BASE}/quotes/taxi-insurance-quote/list`;

/**
 * Motor cycle insurance ...
 */

export const DASH_LINK_MOTOR_CYCLE_INSURANCE_QUOTE_NEW = `${DASH_LINK_BASE}/quotes/motor-cycle-insurance-quote`;
export const DASH_LINK_MOTOR_CYCLE_INSURANCE_QUOTE_DETAILS = `${DASH_LINK_BASE}/quotes/motor-cycle-insurance-quote/details/`;
export const DASH_LINK_MOTOR_CYCLE_INSURANCE_QUOTE_EDIT = `${DASH_LINK_BASE}/quotes/motor-cycle-insurance-quote/edit/`;
export const DASH_LINK_MOTOR_CYCLE_INSURANCE_QUOTE_LIST = `${DASH_LINK_BASE}/quotes/motor-cycle-insurance-quote/list`;

/**
 * Employer liability insurance ...
 */

export const DASH_LINK_EMPLOYER_LIABILITY_INSURANCE_QUOTE_NEW = `${DASH_LINK_BASE}/quotes/employer-liability-insurance-quote`;
export const DASH_LINK_EMPLOYER_LIABILITY_INSURANCE_QUOTE_DETAILS = `${DASH_LINK_BASE}/quotes/employer-liability-insurance-quote/details/`;
export const DASH_LINK_EMPLOYER_LIABILITY_INSURANCE_QUOTE_EDIT = `${DASH_LINK_BASE}/quotes/employer-liability-insurance-quote/edit/`;
export const DASH_LINK_EMPLOYER_LIABILITY_INSURANCE_QUOTE_LIST = `${DASH_LINK_BASE}/quotes/employer-liability-insurance-quote/list`;

/**
 * Fast food delivery insurance ...
 */

export const DASH_LINK_FAST_FOOD_DELIVERY_INSURANCE_QUOTE_NEW = `${DASH_LINK_BASE}/quotes/fast-food-delivery-insurance-quote`;
export const DASH_LINK_FAST_FOOD_DELIVERY_INSURANCE_QUOTE_DETAILS = `${DASH_LINK_BASE}/quotes/fast-food-delivery-insurance-quote/details/`;
export const DASH_LINK_FAST_FOOD_DELIVERY_INSURANCE_QUOTE_EDIT = `${DASH_LINK_BASE}/quotes/fast-food-delivery-insurance-quote/edit/`;
export const DASH_LINK_FAST_FOOD_DELIVERY_INSURANCE_QUOTE_LIST = `${DASH_LINK_BASE}/quotes/fast-food-delivery-insurance-quote/list`;

/**
 * Home insurance ...
 */

export const DASH_LINK_HOME_INSURANCE_QUOTE_NEW = `${DASH_LINK_BASE}/quotes/home-insurance-quote`;
export const DASH_LINK_HOME_INSURANCE_QUOTE_DETAILS = `${DASH_LINK_BASE}/quotes/home-insurance-quote/details/`;
export const DASH_LINK_HOME_INSURANCE_QUOTE_EDIT = `${DASH_LINK_BASE}/quotes/home-insurance-quote/edit/`;
export const DASH_LINK_HOME_INSURANCE_QUOTE_LIST = `${DASH_LINK_BASE}/quotes/home-insurance-quote/list`;

/**
 * Accident management claim ...
 */

export const DASH_LINK_ACCIDENT_MANAGEMENT_CLAIM_NEW = `${DASH_LINK_BASE}/claims/accident-management-claim`;
export const DASH_LINK_ACCIDENT_MANAGEMENT_CLAIM_DETAILS = `${DASH_LINK_BASE}/claims/accident-management-claim/details/`;
export const DASH_LINK_ACCIDENT_MANAGEMENT_CLAIM_EDIT = `${DASH_LINK_BASE}/claims/accident-management-claim/edit/`;
export const DASH_LINK_ACCIDENT_MANAGEMENT_CLAIM_LIST = `${DASH_LINK_BASE}/claims/accident-management-claim/list`;
